import { ReactNode, useMemo } from 'react';
import { Button } from '@/shared/ui';
import ValidAddressFromFormikValues from './ValidAddressFormikValues';
import { ExtendedAddress } from '../types';
import { AddressFormVariant } from '..';

export const AddressTemplate = ({
    address,
    loading,
    onEdit,
    onGoBack,
    onSubmit,
    formVariant,
    hasEditWhenManual,
    defaultAddressValid,
    tryAgainHandler,
    theme = 'default',
    secondaryButtonVariant = 'outlined',
    modal,
    previewFooterBanner,

}: {
    address: ExtendedAddress;
    loading?: boolean;
    formVariant?: AddressFormVariant;
    hasEditWhenManual?: boolean;
    defaultAddressValid?: string;
    onGoBack?: () => void;
    onEdit?: () => void;
    onSubmit?: () => void;
    tryAgainHandler?: () => void;
    theme?: 'default' | 'green',
    secondaryButtonVariant?: 'text' | 'contained' | 'outlined';
    modal?: boolean;
    previewFooterBanner?: ReactNode;
}) => {
    const submitText = useMemo(() => {
        const keys = ['initial_valid_preview', 'auto_valid_preview'];
        if (keys.includes(defaultAddressValid || '')) {
            if (modal) {
                return 'Save';
            }
            return 'Continue';
        }
        return 'Yes, use this address';
    }, [defaultAddressValid, modal]);

    return (
        <div className="flex-col font-atkinsonHyperlegible text-sm md:text-base">
            {
                address && (
                    <ValidAddressFromFormikValues
                        hasEdit={!!(defaultAddressValid || (formVariant === 'manual' && hasEditWhenManual))}
                        values={address}
                        onEditPressed={onEdit}
                        theme={theme}
                    />
                )
            }

            {previewFooterBanner}

            <Button
                className="about_you__address__continue_btn"
                type="submit"
                sx={{
                    width: '100%',
                    marginTop: '1.56rem'
                }}
                onClick={onSubmit}
                loading={loading}
                testId="button-address-template-continue"
                fontClassName='font-bold'
            >
                <span>{submitText}</span>
            </Button>
            <Button
                type="submit"
                sx={{
                    width: '100%',
                }}
                className="about_you__address__back_btn mt-[1.25rem] w-full md-max:mt-[0.44rem]"
                variant={secondaryButtonVariant}
                disabled={loading}
                onClick={defaultAddressValid === 'initial_valid_preview' || defaultAddressValid === 'auto_valid_preview' ? onGoBack : tryAgainHandler}
                testId="button-address-template-back"
                fontClassName='font-bold'
            >
                <span>{`${defaultAddressValid === 'initial_valid_preview' || defaultAddressValid === 'auto_valid_preview' ? 'Back' : 'Try again'}`}</span>
            </Button>
        </div >
    );
};
